export default {"src":"/_next/static/media/search.98c56090.svg","height":423,"width":704};